import React, { Suspense } from "react";
import ErrorBoundary from "../../../../utils/error-boundary"
import OwnershipList from "./ownership-list";
import useOrganizationView from "../organization.service";

const OrganizationOwnershipForAdmin = () => {
    const {ownershipInformation} = useOrganizationView();

    return <>
        <ErrorBoundary
            fallback={<p>Something went wrong in fetching Owener list...</p>}
        >
            <Suspense fallback={<p>Loading Owener list...</p>}>
                <OwnershipList
                    resource={ownershipInformation}
                />
            </Suspense>
        </ErrorBoundary>
    </>
}

export default OrganizationOwnershipForAdmin